/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class VehicleScansDirectiveController {
        public static $inject: string[] = [
            '$rootScope',
            '$state',
            '$window',
            '$filter',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'ConvertUnits',
            'CurrentUser',
            'MicroFrontendOrigin',
            '$dealerwareInternationalizationDateFormats',
            '$dealerwareInternationalizationData'
        ];

        private isMetric: boolean;
        private FuelLabel = 'Fuel';
        private OdometerLabel = 'Odometer';
        private MilesLabel = 'Miles';
        private KmLabel = 'km';
        private GallonsLabel = 'Gallons';
        private LitersLabel = 'L';
        public labels = {};

        constructor(private $rootScope: any,
                    private $state: any,
                    private $window: any,
                    private $filter: any,
                    private DataUtils: any,
                    private $mobilityCompanyAuthentication: any,
                    private $dealerwareLoading: any,
                    private $dealerwareNotification: any,
                    private ConvertUnits: any,
                    private CurrentUser: any,
                    private MicroFrontendOrigin: string,
                    private $dealerwareInternationalizationDateFormats: any,
                    public $dealerwareInternationalizationData: any) {
            this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
            this.getLabels('vehicles');
            this.init();
        }

        public vehicle: any;
        public scanColumns: any;
        public loader: any;

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public get showDownloadControl() : boolean {
            return this.vehicle.vehicleScans !== undefined;
        }

        public pageTransitionError = (response: any) : void => {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public exportCsv = (type: string) : void => {
            if (type === 'all') {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.vehicle.vehicleScans.$exportAllCSV({
                    exportFilePrefix: this.exportFilePrefix,
                    columnDefs: this.exportColumns,
                    finalSuccessCallback: () => { loader.close(); },
                    errorCallback: (response: any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    }
                });
            } else if (type === 'this') {
                this.vehicle.vehicleScans.$exportCSV({
                    exportFilePrefix: this.exportFilePrefix,
                    columnDefs: this.exportColumns
                });
            }
        }

        public handleRowClass = (row : any) : string => {
            if (row.offLotEvent) { return 'off-lot-header-row' }
            if (row.data.off_lot_event_id) { return 'off-lot-sub-row' }
        }

        public hideRow = (row: any) : boolean => { return row.hidden; }

        public isSuperUser = () : boolean => {
            return this.CurrentUser.user.hasRole('superuser');
        };

        public redirectEventHistory = () : void => {
            if (
                this.isSuperUser
                && this.vehicle
                && Object.keys(this.vehicle).length > 0
            ) {
                const locationId = this.vehicle.locationId
                const vehicleId = this.vehicle.vehicleDetails.data.id;
                const eventHistoryHash = `/${locationId}/vehicles/event-history/${vehicleId}`;
                window.parent.postMessage({
                    type: 'routing',
                    hash: eventHistoryHash,
                }, this.MicroFrontendOrigin);
            };
        };

        // private methods, attrs

        private exportFilePrefix: string;
        private exportColumns: any;
        private locationHasGeolite: boolean;

        private init = () : void => {
            const time_zone = this.$mobilityCompanyAuthentication.location.time_zone_name;

            this.locationHasGeolite = this.$mobilityCompanyAuthentication.location.settings.geolite;

            this.scanColumns = [{
                key: 'created_at',
                header: 'Event Created',
                disableTooltip: true,
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'event_received_at',
                header: 'Event Received',
                disableTooltip: true,
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'event_type',
                header: 'Event Type',
                disableTooltip: true,
                dataFilter: (event_type: string) => {
                    var eventType = this.$filter('filterEventType')(event_type);
                    return this.labels.history.event[eventType];
                }
            },{
                key: 'id',
                header: 'Source /\nSerial Number',
                disableTooltip: true,
                dataFilter: (id: number) => {
                    var scan = this.getScan(id),
                        value = this.$filter('filterScanSource')(scan.device);

                    if (scan.serial_number) {
                        value += ' / ' + scan.serial_number;
                    }
                    return this.labels.history.source[value.toLowerCase()];
                }
            },{
                key: 'id',
                header: 'Position',
                disableTooltip: true,
                disableClick: (scan: any) => {
                    return scan.data.event_type === 'Off Lot' || (!scan.data.latitude && !scan.data.longitude);
                },
                onClick: (e: any, scan: any) => {
                    this.$window.open(`https://www.google.com/maps/search/${scan.data.latitude},${scan.data.longitude}`);
                },
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);
                    if (scan.event_type === 'Off Lot') { return 'Multiple'; }
                    return scan.latitude && scan.longitude ? 'Map' : 'N/A';
                }
            },{
                key: 'id',
                header: this.getOdometerLabel(),
                disableTooltip: true,
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);

                    if (!isNaN(parseInt(scan.mileage, 10))) {
                        const convertedValue = this.isMetric
                            ? scan.mileage_in_km
                            : this.ConvertUnits.kmToMiles(scan.mileage_in_km);
                        return convertedValue.toFixed();
                    }
                    return scan.mileage || this.getUnknownValue(scan.device);
                }
            },{
                key: 'id',
                header: 'Fuel',
                disableTooltip: true,
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);
                    const currentFuel = this.ConvertUnits.litersToGallons(scan.fuel_in_liters);
                    const fuelCapacity = this.vehicle.vehicleDetails.data.fuel_capacity;
                    return this.$rootScope.calculateFuelLevel(currentFuel, fuelCapacity);
                }
            },{
                key: 'id',
                header: 'Battery (Voltage)',
                disableTooltip: true,
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);
                    return parseFloat(scan.battery_voltage) > 0 ? scan.battery_voltage : this.getUnknownValue(scan.device);
                }
            },{
                key: 'id',
                header: 'Charge-Level',
                disableTooltip: true,
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);
                    return scan.charge_level ? scan.charge_level + '%' : 'N/A';
                }
            },{
                key: 'id',
                header: 'Created By',
                disableTooltip: true,
                disableClick: (scan: any) => { return scan.data.device === 'mojio' || scan.data.device === 'guidepoint' || scan.data.device === 'toyota' || scan.data.device === 'motorq' },
                onClick: (e: any, vehicle: any) => {
                    $(e.target).attr('href', this.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: vehicle.data.user_id }
                    ));
                },
                dataFilter: (id: number) => {
                    var scan = this.getScan(id);
                    if (scan.event_type === "Off Lot") {
                        return 'System';
                    }
                    if (scan.device === 'mojio' || scan.device === 'guidepoint') {
                        return 'CCD';
                    }
                    if (scan.device === 'toyota') {
                        return 'Toyota Connected';
                    }
                    if (scan.device === 'mercedes_benz') {
                        return 'Mercedes-Benz';
                    }
                    if (scan.device === 'motorq') {
                        return 'Motorq';
                    }
                    return scan.user_name;
                }
            }];

            if (this.locationHasGeolite) {
              this.scanColumns.push({
                  header: 'Actions',
                  actionColumn: true,
                  actions: [{
                      hideFn: (row: any) => !row.headerRow,
                      iconFn: (row: any) => row.expanded ? 'chevron-up' : 'chevron-down',
                      tooltip: (_: any) => 'Show all events',
                      onClick: (row: any) => row.offLotEvent
                        ? this.toggleExpandedOffLotEvent(row)
                        : this.toggleExpandedPollingHistory(row)
                  }]
              });
            }

            this.exportFilePrefix = this.$filter('spaceless')(this.$mobilityCompanyAuthentication.location.name.toLowerCase()) + '_event_history';

            this.exportColumns = [
                {
                    header: 'Event Created',
                    dataFilter: (scan: any) => {
                        return scan.created_at ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(scan.created_at, time_zone)) : '';
                    }
                },{
                    header: 'Event Received',
                    dataFilter: (scan: any) => {
                        return scan.event_received_at ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(scan.event_received_at, time_zone)) : '';
                    }
                },{
                    header: 'Event Type',
                    dataFilter: (scan: any) => {
                        return this.$filter('filterEventType')(scan.event_type);
                    }
                },{
                    header: 'Source / Serial Number',
                    dataFilter: (scan: any) => {
                        var value = this.$filter('filterScanSource')(scan.device);

                        if (scan.serial_number) {
                            value += ' / ' + scan.serial_number;
                        }

                        return value;
                    }
                },{
                    header: 'Position',
                    dataFilter: (scan: any) => {
                        return scan.latitude && scan.longitude ? scan.latitude + ', ' + scan.longitude : 'N/A';
                    }
                },{
                    header: 'Odometer (Miles)',
                    dataFilter: (scan: any) => {
                        if (!isNaN(parseInt(scan.mileage, 10))) {
                            return Math.round(parseInt(scan.mileage, 10)).toString();
                        }
                        return scan.mileage || this.getUnknownValue(scan.device);
                    }
                },{
                    header: 'Fuel (Gallons)',
                    dataFilter: (scan: any) => {
                        return scan.fuel || this.getUnknownValue(scan.device);
                    }
                },{
                    header: 'Battery (Voltage)',
                    dataFilter: (scan: any) => {
                        return parseFloat(scan.battery_voltage) > 0 ? scan.battery_voltage : this.getUnknownValue(scan.device);
                    }
                },{
                    header: 'Charge-Level',
                    dataFilter: (scan: any) => {
                        return scan.charge_level ? scan.charge_level + '%' : 'N/A';
                    }
                },{
                    header: 'Created By',
                    dataFilter: (scan: any) => {
                        if (scan.device === 'mojio' || scan.device === 'guidepoint') {
                            return 'CCD';
                        }
                        if (scan.device === 'motorq') {
                            return 'Motorq';
                        }
                        return scan.user_name;
                    }
                }
            ];
        }

        private getScan = (id: number) : any => {
            var scanIdx = this.vehicle.vehicleScans.data.findIndex((scan: any) => scan.data.id === id);
            return this.vehicle.vehicleScans.data[scanIdx].data;
        }

        private getUnknownValue = (device: string) : string => {
            return this.$filter('filterScanSource')(device).match(/^CCD/) ? 'Unknown' : 'N/A';
        }

        private toggleExpandedOffLotEvent = (headerRow: any) : void => {
            headerRow.expanded = !headerRow.expanded
            this.vehicle.vehicleScans.data.forEach((scan: any) => {
                if (headerRow.data.off_lot_event_id && headerRow.data.off_lot_event_id === scan.data.off_lot_event_id) {
                    if (headerRow.data.id !== scan.data.id) {
                        scan.hidden = !scan.hidden;
                    }
                }
            });
        }

        private toggleExpandedPollingHistory = (headerRow: any) : void => {
          headerRow.expanded = !headerRow.expanded;
          this.vehicle.vehicleScans.data.forEach((scan: any) => {
              if (headerRow.data.event_received_at && headerRow.data.event_received_at === scan.data.event_received_at) {
                  if (headerRow.data.id !== scan.data.id) {
                      scan.hidden = !scan.hidden;
                  }
              }
          });
        }

        private getOdometerLabel(): string {
            const unit = this.isMetric
              ? this.KmLabel
              : this.MilesLabel;
            return `${this.OdometerLabel} (${unit})`;
        }
    }

    // register the controller and directive
    getDealerwareWebComponentsModule().controller('VehicleScansDirectiveController', VehicleScansDirectiveController);

    export class VehicleScansDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleScansDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {vehicle: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/scans/vehicle_scans_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => { }
    }

    getDealerwareWebComponentsModule().directive("dealerwareVehicleScans", () => new VehicleScansDirective());
}
